<template>
    <div class="w-full text-white text-center py-4 flex flex-col gap-4  bottom-0">
        <div class="w-full flex flex-col lg:flex-row justify-center lg:gap-20 gap-4">
            <div class="flex flex-row justify-center lg:justify-between items-center  gap-3 ">
                <span class="mdi mdi-phone text-[#ff0b52] text-5xl"></span>
                <p class="text-start min-w-[225px]"> <span class="text-xl  font-bold">Telefon</span><br>
                    <a class="text-gray-200" href="tel:+90
                        544 488 19 19">+90
                        544 488 19 19</a>
                </p>
            </div>
            <div class="flex flex-row justify-center lg:justify-between items-center  gap-3">
                <span class="mdi mdi-email text-[#ff0b52] text-5xl"></span>
                <p class="text-start"> <span class="text-xl  font-bold">E-posta</span><br><a class="text-gray-200"
                        href="mailto:info@turkiyeeticarethaftasi.com">info@turkiyeeticarethaftasi.com</a>
                </p>
            </div>
        </div>
        <div class="h-20 w-full"></div>
        <div class="w-full flex flex-col lg:flex-row lg:justify-between items-center gap-8 px-8">
            <div class="flex flex-wrap gap-4">
                <a href="https://x.com/treticaret"
                    class="w-8 h-8 lg:w-10 lg:h-10 bg-gray-700 rounded-lg flex justify-center items-center hover:bg-gray-100 hover:text-gray-700 transition">
                    <span class="pi pi-twitter"></span>
                </a>
                <a href="https://www.youtube.com/@T%C3%BCrkiyeETicaretHaftas%C4%B1"
                    class="w-8 h-8 lg:w-10 lg:h-10 bg-gray-700 rounded-lg flex justify-center items-center hover:bg-gray-100 hover:text-gray-700 transition">
                    <span class="pi pi-youtube"></span>
                </a>

                <a href="https://www.instagram.com/turkiyeeticarethaftasi/"
                    class="w-8 h-8 lg:w-10 lg:h-10 bg-gray-700 rounded-lg flex justify-center items-center hover:bg-gray-100 hover:text-gray-700 transition">
                    <span class="pi pi-instagram"></span>
                </a>

                <a href="https://www.tiktok.com/@turkiyeeticarethaftasi"
                    class="w-8 h-8 lg:w-10 lg:h-10 bg-gray-700 rounded-lg flex justify-center items-center hover:bg-gray-100 hover:text-gray-700 transition">
                    <span class="pi pi-tiktok"></span>
                </a>
            </div>
            <div class="flex flex-wrap gap-4">
                <img src="/teh/etid.svg" class="h-8 lg:h-12"></img>
                <img src="/teh/mecliss.svg" class="h-8 lg:h-12"></img>
            </div>
        </div>

        <div class="border-t border-[#ffffff1a] pt-4">
            Türkiye E-Ticaret Haftası © 2025. Tüm Hakları Saklıdır.
        </div>
        <div class="flex flex-col justify-center items-center gap-1 text-sm text-gray-400">
            <span>Etkinlik Yönetimi</span>
            <img src="/teh/Ayyildiz-Logo-Light.png" class="w-36"></img>
        </div>
    </div>
</template>
